import { useEffect, useState } from 'preact/hooks';
import { getRulesLanguage, subscribeRulesLanguage } from './preferences';

export function useRulesLanguage() {
  const [language, setLanguage] = useState(getRulesLanguage);
  useEffect(() => subscribeRulesLanguage(setLanguage), []);
  return language;
}
